var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTripRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 70.865 70.865",
    enableBackground: "new 0 0 70.865 70.865",
    id: "\\u5716\\u5C64_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 1.8424900000000002
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.631,51.701h53.604 c3.146,0,5.697-2.551,5.697-5.697v-7.209c0-3.146-2.551-5.697-5.697-5.697H8.631c-3.146,0-5.698,2.551-5.698,5.697v7.209 C2.933,49.15,5.484,51.701,8.631,51.701z",
    fill: "#1849a9",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.39363
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1849a9",
    points: "50.956,17.816 57.294,33.098 13.572,33.098 19.91,17.816 ",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.39363
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1849a9",
    height: 5.814,
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.39363,
    width: 10.698,
    x: 30.084,
    y: 12.002
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.39363,
    x1: 35.433,
    x2: 35.433,
    y1: 17.816,
    y2: 33.098
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17.12,
    cy: 51.609,
    fill: "#1849a9",
    r: 7.254,
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.39363
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.746,
    cy: 51.609,
    fill: "#1849a9",
    r: 7.254,
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.39363
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripRequest);
export default __webpack_public_path__ + "static/media/trip_request.75f3714e20dbf35f4c719ddcac594110.svg";
export { ForwardRef as ReactComponent };